var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"img-fluid w-100",attrs:{"loop":"","controls":false,"playsinline":"","autoplay":""}},[_c('source',{attrs:{"src":_vm.gif.images.looping.mp4,"type":"video/mp4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }